export var EImageUsageCapacity;
(function (EImageUsageCapacity) {
    EImageUsageCapacity["profile"] = "pr";
    EImageUsageCapacity["title"] = "ti";
    EImageUsageCapacity["poster"] = "po";
    EImageUsageCapacity["content"] = "co";
    EImageUsageCapacity["logo"] = "lo";
})(EImageUsageCapacity || (EImageUsageCapacity = {}));
export var EVideoUsageCapacity;
(function (EVideoUsageCapacity) {
    EVideoUsageCapacity["title"] = "ti";
    EVideoUsageCapacity["content"] = "co";
})(EVideoUsageCapacity || (EVideoUsageCapacity = {}));
export var EMediaUsageStatus;
(function (EMediaUsageStatus) {
    EMediaUsageStatus["active"] = "active";
    EMediaUsageStatus["inactive"] = "inactive";
    EMediaUsageStatus["hidden"] = "hidden";
})(EMediaUsageStatus || (EMediaUsageStatus = {}));
export var EMediaEdgeType;
(function (EMediaEdgeType) {
    EMediaEdgeType["image"] = "image";
    EMediaEdgeType["video"] = "video";
})(EMediaEdgeType || (EMediaEdgeType = {}));
export const CUsedMediaEdge_Keys_HistoryItem = [
    "dateUpdated",
    "status",
    "linkedByTeam",
    "linkedByUser",
    "variationId",
];
